export const BlockHeights = {
  HeaderHeight: 68,
  BalanceHeight: 42,
  DisclaimerHeight: 15,
  ChatEnterMessageBlock: 55,
  DisclaimerHeightIphoneX: 49,
  NavigationMenuHeight: 52,
  ChatHeaderHeight: 68,
};
